import {register} from '../vendor/theme-scripts/theme-sections';
import tabs from '../features/tabs';

const sections = [];

class StoreNav {
  constructor(section) {
    this.section = section
    this.id = section.id
    this.container = section.container

    if( !window.Shopify.designMode ) {
      this.init();
    }
  }

  init() {
    const keys = ['Physiotherapy Clinics', 'Specialty Retailers', 'Trainers']
    for(let i=0 ; i<keys.length ; i++ ) {
      const target = document.querySelector(`[data-store-content="${keys[i]}"]`)
      this.container.querySelector(`[data-tab-content="${keys[i]}"]`).appendChild(target)
    }
  }

  unload() {
  }

  onBlockSelect(evt) {
  }

  onBlockDeselect() {
  }
}

const storeNav = {
  onLoad() {
    sections[this.id] = new StoreNav(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
}

register('store-nav', [storeNav, tabs]);
